import { render } from "./MainIndex.vue?vue&type=template&id=73ea3d63"
import script from "./MainIndex.vue?vue&type=script&lang=js"
export * from "./MainIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__